import { labelsParamsAdapters } from '../adapters/LabelsParamsAdapter';
import { LensPackage } from '../meta/IBrain';
import { IStep } from '../meta/IStep';
import { Parameter } from './Parameter';

export class Step implements IStep<number, Parameter> {
  params: Parameter[];
  progressive: number;
  key: string;
  title: string;
  analytics_ID: string;
  analytics_section: string;
  navigated: boolean;
  cheapestPackages: LensPackage[];
  skipped?: boolean;

  constructor(
    key: string,
    title: string,
    analytics_ID: string,
    analytics_section: string,
    progressive: number,
    parameters: Parameter[],
    navigated = false,
    skipped = false
  ) {
    this.key = key;
    this.title = title;
    this.analytics_ID = analytics_ID;
    this.analytics_section = analytics_section;
    this.progressive = progressive;
    this.params = parameters;
    this.navigated = navigated;
    this.cheapestPackages = [];
    this.skipped = skipped;
  }

  getTitle(): string {
    let ret = '';
    if (this.params) {
      ret = labelsParamsAdapters.adaptReverse(this.params).title;
    }
    return ret;
  }
}
